import { createContext } from 'react';

import { PopoverContextType } from './popover-root.types';

export const PopoverContext = createContext<PopoverContextType | null>(null);
